import Footer from '../components/layout/footer';
import { useLanguage } from '../context/LanguageContext';

const HERO_IMAGE = '/assets/images/maisonadjiwallpaper.webp';
const SECTION_IMAGE = '/assets/images/maisonadjiwallpapergreen.webp';

export default function AboutPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-neutral-950 text-white">
      {/* Hero */}
      <header className="relative min-h-[50vh] md:min-h-[60vh] flex flex-col justify-end overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/80 to-neutral-950/40" />
        <div className="relative z-10 px-6 md:px-8 pb-16 md:pb-24 pt-28 md:pt-32 max-w-4xl">
          <p className="font-['Sora'] text-xs tracking-[0.35em] text-amber-200/70 uppercase mb-3">
            Maison Adji
          </p>
          <h1 className="font-['Sora'] text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white max-w-2xl">
            {t('about.title')}
          </h1>
          <p className="mt-4 font-['Rubik'] text-white/60 text-sm md:text-base max-w-lg leading-relaxed">
            {t('about.subtitle')}
          </p>
        </div>
      </header>

      {/* Section 1 — Histoire */}
      <section className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <div className="h-px w-12 bg-amber-400/60 mb-10" aria-hidden />
        <p className="font-['Sora'] text-lg md:text-xl text-white/95 leading-relaxed mb-8">
          {t('about.section1.lead')}
        </p>
        <p className="font-['Rubik'] text-white/75 leading-[1.85] mb-6">
          {t('about.section1.p1')}
        </p>
        <p className="font-['Rubik'] text-white/75 leading-[1.85]">
          {t('about.section1.p2')}
        </p>
      </section>

      {/* Image de transition */}
      <figure className="w-full aspect-[4/3] md:aspect-[21/9] overflow-hidden">
        <img
          src={SECTION_IMAGE}
          alt=""
          className="w-full h-full object-cover object-center opacity-90"
        />
      </figure>

      {/* Section 2 — Savoir-faire */}
      <section className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <h2 className="font-['Sora'] text-sm tracking-[0.3em] text-amber-200/80 uppercase mb-8">
          {t('about.section2.title')}
        </h2>
        <p className="font-['Rubik'] text-white/75 leading-[1.85] mb-6">
          {t('about.section2.p1')}
        </p>
        <p className="font-['Rubik'] text-white/75 leading-[1.85]">
          {t('about.section2.p2')}
        </p>
      </section>

      {/* Citation de clôture */}
      <section className="border-t border-white/10 bg-white/[0.02]">
        <div className="max-w-2xl mx-auto px-6 py-16 md:py-20">
          <blockquote className="relative pl-6 md:pl-8 border-l-2 border-amber-400/50">
            <p className="font-['Sora'] text-xl md:text-2xl text-white/95 leading-relaxed font-light italic">
              {t('about.quote')}
            </p>
          </blockquote>
        </div>
      </section>

      <Footer />
    </div>
  );
}
